import ChapterDietsPage from "./pages/ChapterDietsPage";
import ChapterDietDetailsPage from "./pages/ChapterDietDetailsPage";
import ChaptersPage from "./pages/ChaptersPage";
import ChapterDetailsPage from "./pages/ChapterDetailsPage";
import ChapterApplicationsPage from "./pages/ChapterApplicationsPage";
import ChapterUpgradeApplicationsPage from "./pages/ChapterUpgradeApplicationsPage";
import ChapterUpgradeApplicationDetailPage from "./pages/ChapterUpgradeApplicationDetailPage";
import ChapterReferralsPage from "./pages/ChapterReferralsPage";
import InstitutionContactsPage from "./pages/InstitutionContactsPage";
import ChapterRegisterPage from "./pages/ChapterRegisterPage";
import ChapterEventsPage from "./pages/ChapterEventsPage";
import ChapterEventDetailPage from "./pages/ChapterEventDetailPage";
/**
 * Gated on the PRIVILEGE, not the `admin` role.
 *
 * These screens already gate themselves on the same privilege (PageGate), and
 * the API enforces it too — the role check on top of that only decided who
 * could get as far as the page, and it locked out the executives the
 * secretariat had deliberately granted the privilege to. The privilege is the
 * question being asked everywhere else, so it is the one asked here.
 */
export const chapterRoutes = [
  {
    path: "/chapter/diets",
    element: <ChapterDietsPage />,
    perms: ["chapter.diet.access"],
  },
  {
    path: "/chapter/diets/:id",
    element: <ChapterDietDetailsPage />,
    perms: ["chapter.diet.access"],
  },
  {
    path: "/chapter/chapters",
    element: <ChaptersPage />,
    perms: ["chapter.access"],
  },
  {
    path: "/chapter/chapters/:id",
    element: <ChapterDetailsPage />,
    perms: ["chapter.access"],
  },
  {
    path: "/chapter/referrals",
    element: <ChapterReferralsPage />,
    roles: ["chapter_chairman", "chapter_secretary"],
  },
  {
    path: "/chapter/my-applications",
    element: <ChapterApplicationsPage />,
    roles: ["chapter_chairman", "chapter_secretary"],
  },
  {
    path: "/chapter/my-upgrade-applications",
    element: <ChapterUpgradeApplicationsPage />,
    roles: ["chapter_chairman", "chapter_secretary"],
  },
  {
    path: "/chapter/my-upgrade-applications/:id",
    element: <ChapterUpgradeApplicationDetailPage />,
    roles: ["chapter_chairman", "chapter_secretary"],
  },
  {
    // The chairman's own register. Chairman alone, unlike the endorsement
    // screens above — this one lists members rather than acting on
    // applications, so the secretary is not swept in with him.
    path: "/chapter/members",
    element: <ChapterRegisterPage />,
    roles: ["chapter_chairman"],
  },
  {
    path: "/chapter/institution-contacts",
    element: <InstitutionContactsPage />,
    roles: ["chapter_chairman", "chapter_secretary"],
  },
  {
    // The chapter's own CPD events. Both offices, like the endorsement queues
    // above — running the chapter's events is secretarial work as much as the
    // chairman's, and the API scopes both from the same leadership record.
    path: "/chapter/events",
    element: <ChapterEventsPage />,
    roles: ["chapter_chairman", "chapter_secretary"],
  },
  {
    path: "/chapter/events/:id",
    element: <ChapterEventDetailPage />,
    roles: ["chapter_chairman", "chapter_secretary"],
  },
];
